export default __webpack_public_path__ + "static/media/course-shape-bg.0b2d729a.jpg";